
import {DefaultSettingsResponseProps, DefaultSettingsKeysProps} from '../types';
import DefaultSettingsBlock from './DefaultSettingsBlock';
import {FC} from 'react';
import {useTranslation} from 'react-i18next';

type DefaultSettingsProps = {
  defaultSettings: DefaultSettingsResponseProps[];
  defaultSettingsKeys: DefaultSettingsKeysProps;
}

const DefaultSettings: FC<DefaultSettingsProps> = (
    {defaultSettings, defaultSettingsKeys}
) => {
  const {t} = useTranslation('targetTaskTime');

  return (
    <div className="default-settings">
      <h2 className="subheader">{t('defaultSettingsTitle')}</h2>
      <div className="default-settings__wrapper">
        <DefaultSettingsBlock
          defaultSettings={defaultSettings}
          defaultSettingsKeys={defaultSettingsKeys.taskTimeSettings}
          className="default-settings__task-time"
        />
        <DefaultSettingsBlock
          defaultSettings={defaultSettings}
          defaultSettingsKeys={defaultSettingsKeys.processTimeSettings}
        />
      </div>

    </div>
  );
};

export default DefaultSettings;
